/**
 * API service for prompt improvement
 */

import { apiPost } from "./apiClient";
import type { ImprovePromptRequest, ImprovePromptResponse } from "@shared/schemas/api";

export type { ImprovePromptRequest, ImprovePromptResponse } from "@shared/schemas/api";

type ImprovePromptResult = ImprovePromptResponse & { isRateLimited?: boolean };

/**
 * Call the improve-prompt API
 * @param params - Parameters including the prompt to improve
 * @returns The improved prompt
 */
export async function improvePrompt(
  params: ImprovePromptRequest
): Promise<ImprovePromptResult> {
  try {
    return await apiPost<ImprovePromptResponse>(
      "/api/improve-prompt",
      params
    );
  } catch (error) {
    console.error("Error calling improve-prompt:", error);
    if ((error as Error & { isRateLimited?: boolean }).isRateLimited) {
      return { success: false, isRateLimited: true };
    }
    return {
      success: false,
      error: error instanceof Error ? error.message : "Failed to improve prompt",
    };
  }
}
